import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CurrentUser } from '../interfaces/currentUser.interface';
import { AllOW_PARENT_ORIGINS } from 'src/environments/AllowParentOrigins';

export enum FrameMessageType {
  READY = 'READY',
  ERROR = 'ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  MESSAGE = 'MESSAGE',
  FILTERS = 'FILTERS',
  UPDATE_FILTERS = 'UPDATE_FILTERS',
  CHECK_READY = 'CHECK_READY',
}
export interface MessagePayload {
  token: string;
  selectedLocationIds: number[];
  selectedRegionsIds: number[];
  userData: any;
  parentFullUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class CommunicationService {
  locationsSelected$ = new BehaviorSubject<number[]>([]);
  regionsSelected$ = new BehaviorSubject<any[]>([]);
  currentUser$ = new BehaviorSubject<CurrentUser | null>(null);

  token = signal<string>('');
  currentUser = signal<CurrentUser | null>(null);
  currentOrigin = signal<string>('');
  isAppReady = signal<boolean>(false);
  parentFullUrl = signal<string>('');

  constructor() {
    this.waitingParentToCheckIfChildReady();
  }

  waitingParentToCheckIfChildReady() {
    window.addEventListener('message', event => {
      if (!event.origin || !AllOW_PARENT_ORIGINS.includes(event.origin)) {
        return;
      }
      if (
        event.data.type === FrameMessageType.CHECK_READY &&
        !this.isAppReady()
      ) {
        this.currentOrigin.set(event.origin);
        this.sendMessageToParent(FrameMessageType.READY);
        return;
      }
      this.receiveMessageFromParent(event.data.type, event.data.data);
    });
  }

  sendMessageToParent(type: FrameMessageType, payload?: MessagePayload) {
    const message = {
      type,
      payload,
    };
    window.parent.postMessage(message, this.currentOrigin());
  }

  receiveMessageFromParent(type: FrameMessageType, payload: MessagePayload) {
    if (type === FrameMessageType.FILTERS) {
      this.locationsSelected$.next(payload.selectedLocationIds);
      this.regionsSelected$.next(payload.selectedRegionsIds);
      this.currentUser$.next(payload.userData);
      this.currentUser.set(payload.userData);
      this.token.set(payload.token);
      this.isAppReady.set(true);
      this.parentFullUrl.set(payload.parentFullUrl);
    } else if (type === FrameMessageType.UPDATE_FILTERS) {
      for (const [key, value] of Object.entries(payload)) {
        if (key === 'selectedLocationIds') {
          this.locationsSelected$.next(value);
        } else if (key === 'selectedRegionsIds') {
          this.regionsSelected$.next(value);
        } else if (key === 'userData') {
          this.currentUser$.next(value);
          this.currentUser.set(value);
        } else if (key === 'token') {
          this.token.set(value);
        }
      }
    }
  }
}
